import { Box } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { LicensesPageContent } from "Components/Licenses/LicensesPageContent/LicensesPageContent";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";

export const LicensesPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Licenses)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null, // "root" page, nowhere higher to go
      }}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <LicensesPageContent />
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default LicensesPage;
